exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-active .al img{filter:grayscale(0)}.al img{filter:grayscale(100%)}", ""]);

// exports
